export const imgRegex = /data:image\/[^;]+;base64,([^"]+)/;
export const whiteSpaceEmptyStrRegex = /^\s*$/;
export const emailRegex = /^[a-zA-Z0-9._%±]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/;
export const phoneNoRegex =
  /^([789]{1})([\d]{3})[(\D\s)]?[\d]{3}[(\D\s)]?[\d]{3}$/;
export const dateTimeRegex =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/;
export const dateRegex =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$|^\d{2}-\d{4}$/;
export const urlRegex = /https?:\/\/(?:www\.)?[^\s/$.?#].[^\s]*/gi;
